import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
    selectIsPartiposterTagsChipOpen,
    selectIsResubmittedTypeChipOpen,
    selectIsVoteTypeChipOpen,
    setSubmissionChips,
} from 'state/review'
/**
 * Hook to check the current tooltip type and its anchor element
 *
 * @returns the tooltip type and anchor element , also the function to update the state
 */
interface TooltipState {
    anchorEl: HTMLElement | null
    current: string | null
}
export enum ToolTipNames {
    GENERIC_FILTER = 'GENERIC_FILTER',
    GENERIC_SORT = 'GENERIC_SORT',
}

export const useDisplayTooltip = (): [
    TooltipState,
    (tooltipName: string | null, e?: React.MouseEvent<HTMLElement>) => void,
] => {
    const [sortAndFilterTooltip, setIsSortAndFilterTooltip] = useState<TooltipState>({
        anchorEl: null,
        current: null,
    })
    const handleUpdateTooltipState = (tooltipName: string | null, e?: React.MouseEvent<HTMLElement>) => {
        if (e) {
            setIsSortAndFilterTooltip({
                ...sortAndFilterTooltip,
                anchorEl: e.currentTarget,
                current: tooltipName,
            })
        } else {
            setIsSortAndFilterTooltip({
                ...sortAndFilterTooltip,
                anchorEl: null,
                current: null,
            })
        }
    }

    return [sortAndFilterTooltip, handleUpdateTooltipState]
}

export const useAddCustomizeFilter = () => {
    const isVoteTypeChipOpen = useSelector(selectIsVoteTypeChipOpen)
    const isPartiposterTagsChipOpen = useSelector(selectIsPartiposterTagsChipOpen)
    const isResubmittedTypeChipOpen = useSelector(selectIsResubmittedTypeChipOpen)
    const dispatch = useDispatch()

    const handleOnClickFilter = (
        isVoteTypeChipOpen: boolean,
        isPartiposterTagsChipOpen: boolean,
        isResubmittedTypeChipOpen: boolean,
        chipId: string,
        callback?: () => void,
    ) => {
        dispatch(
            setSubmissionChips({
                isVoteTypeChipOpen,
                isPartiposterTagsChipOpen,
                isResubmittedTypeChipOpen,
            }),
        )
        setTimeout(() => {
            document.getElementById(chipId)?.click()
        }, 200)
        if (callback) {
            callback()
        }
    }

    const handleOnClickVoteAndComment = (callback?: () => void) =>
        handleOnClickFilter(
            true,
            isPartiposterTagsChipOpen,
            isResubmittedTypeChipOpen,
            'submission-filter-vote-and-comment',
            callback,
        )

    const handleOnClickPartiposterTags = (callback?: () => void) =>
        handleOnClickFilter(
            isVoteTypeChipOpen,
            true,
            isResubmittedTypeChipOpen,
            'submission-filter-partiposter-tags',
            callback,
        )

    const handleOnClickResubmittedType = (callback?: () => void) =>
        handleOnClickFilter(
            isVoteTypeChipOpen,
            isPartiposterTagsChipOpen,
            true,
            'submission-filter-resubmitted',
            callback,
        )

    const handleClosePartiposterTags = (callback?: () => void) =>
        handleOnClickFilter(
            isVoteTypeChipOpen,
            false,
            isResubmittedTypeChipOpen,
            'submission-filter-partiposter-tags',
            callback,
        )

    return [
        handleOnClickVoteAndComment,
        handleOnClickPartiposterTags,
        handleOnClickResubmittedType,
        handleClosePartiposterTags,
    ]
}
